module.exports = __webpack_public_path__ + "static/media/4ODA8.3b2e5836.jpg";